import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Palmtree } from 'lucide-react';
import { useVacationMode } from '../features/vacation';
import { VacationConfirmDialog } from './vacation/VacationConfirmDialog';

export function VacationToggle() {
  const { isVacationMode, toggleVacationMode } = useVacationMode();
  const [showConfirmation, setShowConfirmation] = useState(false);

  const handleToggleClick = () => {
    if (!isVacationMode) {
      setShowConfirmation(true);
    } else {
      toggleVacationMode();
    }
  };

  return (
    <>
      <button
        onClick={handleToggleClick}
        className={`relative p-1.5 rounded-lg transition-all duration-300 hover:bg-secondary flex items-center gap-1.5 ${
          isVacationMode ? 'bg-primary/20' : ''
        }`}
        aria-label="Toggle vacation mode"
      >
        <div className="relative w-5 h-5">
          <Palmtree 
            className={`w-5 h-5 ${
              isVacationMode ? 'text-primary' : 'text-muted-foreground'
            } transition-colors`} 
          />
          {isVacationMode && (
            <div className="absolute inset-0 bg-primary/20 blur-xl rounded-full animate-pulse" />
          )}
        </div>
        <span className={`text-xs whitespace-nowrap ${
          isVacationMode ? 'text-primary' : 'text-muted-foreground'
        }`}>
          Vacation Mode
        </span>
      </button>

      <AnimatePresence>
        {showConfirmation && (
          <VacationConfirmDialog
            onConfirm={() => {
              toggleVacationMode();
              setShowConfirmation(false);
            }}
            onCancel={() => setShowConfirmation(false)}
          />
        )}
      </AnimatePresence>
    </>
  );
}